import { render, staticRenderFns } from "./modifyPassword.vue?vue&type=template&id=15d01b3a&scoped=true&"
import script from "./modifyPassword.vue?vue&type=script&lang=js&"
export * from "./modifyPassword.vue?vue&type=script&lang=js&"
import style0 from "./modifyPassword.vue?vue&type=style&index=0&id=15d01b3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d01b3a",
  null
  
)

export default component.exports